import React, { useEffect, useState } from "react";
import SideNav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from "react-icons/io";
import { NavLink, useNavigate } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import axios from "axios";
import { MdOutlineDashboard } from "react-icons/md";
import { PiWalletLight } from "react-icons/pi";
import { FaHistory, FaShoppingCart } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import Home from "./pages/Home";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from "react-router-dom";
// import Navbarr from "./Navbarr";
import ScrollToTop from "./ScrollToTop";
import Register from "./pages/Register";
import SignIn from "./pages/SignIn";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
// import Pricing from "./notused/Pricing";
import About from "./pages/About";
import Account from "./pages/Account";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./NotFound";
import LimitedOffer from "./pages/LimitedOffer";
import LeadsShop from "./pages/LeadsShop";
import Blogs from "./pages/Blogs";
import LeadsForm from "./pages/LeadsForm";
import MyDashboard from "./pages/MyDashboard";
import MyDashboardAdmin from "./pages/dashboard/MyDashboardAdmin";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./App.css";
// import { transform } from 'lodash';
import ManageFunds from "./pages/ManageFunds";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";
import Users from "./pages/dashboard/Users";
import Policy from "./pages/Policy";
import Terms from "./pages/Terms";
// import AutoLeads from './components/AutoLeads';
import OpenTicket from "./components/OpenTicket";
import UserHistory from "./pages/UserHistory";

function App() {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/" element={<Root />}>
          <Route index element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/sign-in" element={<SignIn />} />
          {/* <Route path="/CallCenterRegistration" element={<CallCenterRegistration />} /> */}
          {/* <Route path="/SubmitInquiry" element={<SubmitInquiry />} /> */}
          {/* <Route path="/build-va-team" element={<BuildVa />} /> */}
          <Route path="/blogs" element={<Blogs />} />
          {/* <Route path="/pricing" element={<Pricing />} /> */}
          <Route path="/account" element={<Account />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/manage-balance" element={<ManageFunds />} />

          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/ForgetPassword" element={<ForgetPassword />} />
          <Route path="/limited-offer" element={<LimitedOffer />} />

          <Route path="/leads-shop" element={<LeadsShop />} />

          <Route path="/leads-form" element={<LeadsForm />} />

          <Route path="/my-dashboard" element={<MyDashboard />} />
          <Route path="/my-admin-dashboard" element={<MyDashboardAdmin />} />

          <Route path="/users" element={<Users />} />
          <Route path="/privacy-policy" element={<Policy />} />
          <Route path="/open-ticket" element={<OpenTicket />} />
          <Route path="/purchase-history" element={<UserHistory />} />

          
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </>
    )
  );

  return (
    <Elements stripe={stripePromise}>
      <div className={`app`}>
        <RouterProvider router={router}></RouterProvider>
      </div>
    </Elements>
  );
}

export default App;

const Root = () => {
  const [expanded, setExpanded] = useState(false);
  const [wallet, setWallet] = useState(null);
  const navigate = useNavigate();
  const apiKey = process.env.REACT_APP_API_KEY;
  const [uid, setUid] = useState(null);

  const handleToggle = () => {
    setExpanded(!expanded);
  };
  const auth = getAuth();

  const [user, setUser] = useState({
    full_name: "",
    email: "",
    phone: "",
    userName: "",
    isAdmin: "",
    isModerator: "",
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUid(user.uid);

        fetchWalletDetails(user.uid);
      } else {
        setUid(null);
        setWallet(null);
      }
    });
    return () => unsubscribe();
  }, []);
  useEffect(() => {
    const fetchUserData = async () => {
      if (!uid) return;

      try {
        const response = await fetch(
          `https://api.v1.spotyourleads.com/user/${uid}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": apiKey,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }

        const userData = await response.json();

        setUser(userData);
        localStorage.setItem("isAdmin", userData.isAdmin);
        localStorage.setItem("isModerator", userData.isModerator);
      } catch (error) {
        console.error("Error fetching user data:", error.message);
      }
    };

    fetchUserData();
  }, [uid, apiKey]);

  const fetchWalletDetails = async (uid) => {
    try {
      const response = await axios.get(
        `https://api.v1.spotyourleads.com/user/${uid}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        }
      );
      setWallet(response.data.wallet);
    } catch (error) {
      console.error("Error fetching wallet details: ", error);
    }
  };
  useEffect(() => {
    if (!uid) return;

    const userDocRef = doc(db, "users", uid);
    const unsubscribe = onSnapshot(userDocRef, (snapshot) => {
      if (snapshot) {
        fetchWalletDetails(uid);
      }
    });

    return () => unsubscribe();
  }, [uid]);
  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUid(null);
      setWallet(null);
      navigate("/sign-in");
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  return (
    <>
      <ScrollToTop />
      {/* <div id="testing-banner">🚧 This site is currently under testing mode 🚧</div> */}

      <header>
        {!uid ? (
          <>
            <NavLink to="/sign-in">
              <button>
                <CgProfile />
                Login
              </button>
            </NavLink>

            <NavLink to="/register">
              <button>
                <CgProfile />
                Register
              </button>
            </NavLink>
          </>
        ) : (
          <>
            {uid ? (
              <>
              <div className="wallet">
                <NavLink to="/open-ticket">
                 Open Ticket
                </NavLink>
              </div>
              <div className="wallet">
                <NavLink to="/manage-balance">
                  <PiWalletLight /> {wallet ? ` $${wallet}` : "$0"}
                </NavLink>
              </div>
              </>
            ) : null}
            <button onClick={handleLogout}>Log out</button>
          </>
        )}
      </header>
      <SideNav
        onToggle={handleToggle}
        expanded={expanded} // Controlled by state
      >
        {/* Custom Toggle */}
        <button className="custom-toggle" onClick={handleToggle}>
          {expanded ? (
            <IoIosArrowDropleftCircle />
          ) : (
            <IoIosArrowDroprightCircle />
          )}
        </button>
        <div className="nav-column">
          <SideNav.Nav defaultSelected="home">
            <div className="sidenav-logo" onClick={handleToggle}>
              <img src="images/logoo.svg" alt="Logo" />
            </div>
            <NavItem eventKey="home" onClick={() => navigate("/")}>
              <NavIcon>
                <NavLink to="/">
                  <img className="nav-icon" src="images/Layer_2.svg" alt="" />
                </NavLink>
              </NavIcon>
              <NavText>
                <NavLink to="/">Home</NavLink>
              </NavText>
            </NavItem>
            {uid ? (
              <NavItem
                eventKey="leads-shop"
                onClick={() => navigate("/leads-shop")}
              >
                <NavIcon>
                  <NavLink to="/leads-shop">
                    <FaShoppingCart className="nav-icon profile-icon" />
                  </NavLink>
                </NavIcon>
                <NavText>
                  <NavLink to="/leads-shop">Leads Shop</NavLink>
                </NavText>
              </NavItem>
            ) : (
              <NavItem
                eventKey="leads-shopp"
                onClick={() => navigate("/sign-in")}
              >
                <NavIcon>
                  <NavLink to="/sign-in">
                    <FaShoppingCart className="nav-icon profile-icon" />
                  </NavLink>
                </NavIcon>
                <NavText>
                  <NavLink to="/sign-in">Leads Shop</NavLink>
                </NavText>
              </NavItem>
            )}
            <NavItem eventKey="info" onClick={() => navigate("/about-us")}>
              <NavIcon>
                <NavLink to="/about-us">
                  <img
                    className="nav-icon"
                    src="images/Vector (2).svg"
                    alt=""
                  />
                </NavLink>
              </NavIcon>
              <NavText>
                <NavLink to="/about-us">About</NavLink>
              </NavText>
            </NavItem>

            <NavItem
              eventKey="manage-balance"
              onClick={() =>
                uid ? navigate("/manage-balance") : navigate("/sign-in")
              }
            >
              <NavIcon>
                <NavLink to={uid ? "/manage-balance" : "/sign-in"}>
                  <img className="nav-icon" src="images/imgnav.svg" alt="" />
                </NavLink>
              </NavIcon>
              <NavText>
                <NavLink to={uid ? "/manage-balance" : "/sign-in"}>
                  Manage Balance
                </NavLink>
              </NavText>
            </NavItem>

            <NavItem
              eventKey="my-admin-dashboard"
              onClick={() =>
                user.isAdmin
                  ? navigate("/my-admin-dashboard")
                  : uid
                  ? navigate("/my-dashboard")
                  : navigate("/sign-in")
              }
            >
              <NavIcon>
                <NavLink
                  to={
                    user.isAdmin
                      ? "/my-admin-dashboard"
                      : uid
                      ? "my-dashboard"
                      : "/sign-in"
                  }
                >
                  <MdOutlineDashboard className="nav-icon profile-icon" />
                </NavLink>
              </NavIcon>
              <NavText>
                <NavLink
                  to={
                    user.isAdmin
                      ? "/my-admin-dashboard"
                      : uid
                      ? "my-dashboard"
                      : "sign-in"
                  }
                >
                  My Dashboard
                </NavLink>
              </NavText>
            </NavItem>




            


            { uid? (
              <NavItem
                eventKey="purchase-history"
                onClick={() =>
               navigate("/purchase-history")
                }
              >
                <NavIcon>
                  <NavLink
                    to="/purchase-history"
                    
                  >
                    <FaHistory className="nav-icon profile-icon" />
                  </NavLink>
                </NavIcon>
                <NavText>
                  <NavLink
                    to="purchase-history"
                  >
                    Purchase History
                  </NavLink>
                </NavText>
              </NavItem>
            ) : null}


            {user.isAdmin || user.isModerator ? (
              <NavItem
                eventKey="users"
                onClick={() =>
                  user.isAdmin || user.isModerator
                    ? navigate("/users")
                    : navigate("/sign-in")
                }
              >
                <NavIcon>
                  <NavLink
                    to={
                      user.isAdmin || user.isModerator ? "/users" : "/sign-in"
                    }
                  >
                    <FaUsers className="nav-icon profile-icon" />
                  </NavLink>
                </NavIcon>
                <NavText>
                  <NavLink
                    to={user.isAdmin || user.isModerator ? "/users" : "sign-in"}
                  >
                    All Users
                  </NavLink>
                </NavText>
              </NavItem>
            ) : null}

            <NavItem
              eventKey="limited-offer"
              className="pricing-nav"
              onClick={() =>
                uid ? navigate("/limited-offer") : navigate("/sign-in")
              }
            >
              <NavIcon>
                <NavLink to={uid ? "/limited-offer" : "/sign-in"}>
                  <img
                    className="nav-icon differ"
                    src="images/pricing.svg"
                    alt=""
                  />
                </NavLink>
              </NavIcon>
              <NavText>
                <NavLink to={uid ? "/limited-offer" : "/sign-in"}>
                  Limited Offers
                </NavLink>
              </NavText>
            </NavItem>

            <NavItem eventKey="faqs" onClick={() => navigate("/blogs")}>
              <NavIcon>
                <NavLink to="/blogs">
                  <img className="nav-icon" src="images/Group 3.svg" alt="" />
                </NavLink>
              </NavIcon>
              <NavText>
                <NavLink to="/blogs">FAQs</NavLink>
              </NavText>
            </NavItem>

            <NavItem
              eventKey="profile"
              className="nav-item-profile"
              onClick={() =>
                uid ? navigate("/account") : navigate("/sign-in")
              }
            >
              <NavIcon>
                <NavLink to={uid ? "/account" : "/sign-in"}>
                  <CgProfile className="nav-icon profile-icon" />
                </NavLink>
              </NavIcon>
              <NavText>
                <NavLink to={uid ? "/account" : "/sign-in"}>Account</NavLink>
              </NavText>
            </NavItem>
          </SideNav.Nav>
        </div>
      </SideNav>

      <div className={expanded ? "App1" : ""}>
        <Outlet />
      </div>
    </>
  );
};
